
<div class="row" *ngIf="_isReady">

    <div class="col-md-8">
        <h5 class="blue2">{{filter.name}}</h5>
        <div *ngIf="filter.filterTypeId == 2 && filter!=null">
            <mat-card>
                Esse filtro utiliza o total de dezenas que aparecem dentro da area destacada do quadro abaixo.

                <kt-grid-numbers [cols]="cols" [rows]="rows" [numberList]="numberList" [headerNumberList]="headerNumberList" [checkedNumbers]="filter.data">
                </kt-grid-numbers>
            </mat-card>
        </div>

        <div *ngIf="filter.filterTypeId == 8">
            <mat-card>
                Esse filtro considera a quantidade de colunas em uma aposta em que nenhuma dezena está marcada.
            </mat-card>

        </div>
        <div *ngIf="filter.filterTypeId == 7">
            <mat-card>
                Esse filtro considera a quantidade de linhas em uma aposta em que nenhuma dezena está marcada.
            </mat-card>

        </div>

        <div *ngIf="filter.filterTypeId == 9">
            <mat-card>
                Esse filtro considera a quantidade de dezenas que tem um espelho.
                <br>
                Por exemplo a dezena <span class="red">32</span> é espelho da dezena <span class="red">23</span> ,

                como a dezena <span class="red">15</span> é espelho da dezena <span class="red">51</span>
            </mat-card>

        </div>
        <div *ngIf="filter.filterTypeId == 4">
            <mat-card>
                Esse filtro considera a quantidade total de dezenas ímpares da aposta.
            </mat-card>
        </div>
        <div *ngIf="filter.filterTypeId == 3">

            <mat-card>
                Esse filtro considera a quantidade total de dezenas pares da aposta.
            </mat-card>
        </div>
        <div *ngIf="filter.filterTypeId == 200">

            <mat-card>
                Esse filtro funciona da seguinte maneira: <br>A primeira aposta sempre é mantida, a segunda sera comparada com a primeira. Caso possua uma quantidade de números iguais fora dos limites do filtro, a aposta é mantida, caso contrario descartada.
                A próxima aposta analisada é comparada com todas as que foram mantidas anteriormente. Isso pode causar um processamento exponencial com tempo de processamento demasiadamente severo.<br>
                Devido a essa caracteristica, não é permitido deixar esse filtro selecionado com o padrão ativado.<br>
                Especificamente na aposta ele pode ser ativado. MAs possui uma limitação de  funcionamento somente enquanto a aposta tem menos de 1000 jogos aprovados. Pois nessa situação  já está sendo multiplicado por 1000 o tempo de filtragem.
            </mat-card>

        </div>
        <div *ngIf="filter.filterTypeId == 5">
            <mat-card>
                Esse filtro considera a coluna com mais dezenas e a coluna com menos dezenas e apartir dela verifica se essas quantidades estão entre o
                mínimo e máximo estipulado.
            </mat-card>
        </div>
        <div *ngIf="filter.filterTypeId == 6">
            <mat-card>
                Esse filtro considera a linha com mais dezenas e a linha com menos dezenas e apartir dela verifica se essas quantidades estão entre o
                mínimo e máximo estipulado.
            </mat-card>
        </div>
        <div *ngIf="filter.filterTypeId == 1">
            <mat-card>
                Esse filtro considera a maior sequência de numeros em uma aposta apartir dela verifica se essa
                quantidade está entre o mínimo e máximo estipulado.
                <br> Por exemplo na aposta <span class="green">02 03 </span><span class="blue">07 </span><span
                    class="red">09 10 11 </span> a sequência considerada é:
                <span class="red">09 10 11 </span>
            </mat-card>
        </div>
        <div *ngIf="filter.filterTypeId == 11">
            <mat-card>
                Esse filtro considera a maior sequência de números ímpares em uma aposta apartir dela verifica se essa
                quantidade está entre o mínimo e máximo estipulado.
                <br> Por exemplo na aposta
                <span class="black">02 </span>
                <span class="red">03 </span>
                <span class="black">04 </span>
                <span class="red">05 </span>
                <span class="red">07 </span>
                <span class="black">08 </span>
                <span class="red">09 </span>
                <span class="green">15 </span>
                <span class="black">16 </span>
                <span class="green">17 </span>
                <span class="black">20 </span>
                <span class="blue">21 </span>
                a sequência considerada é:
                <span class="red">03 05 07 09 </span>
            <br>
                    Observe que os pares da aposta são desconsiderados, então se existe ou não pares entre a sequencia é
                    irrelevante.

            </mat-card>
        </div>
        <div *ngIf="filter.filterTypeId == 16">
            <mat-card>
                Esse filtro considera a maior sequência de números pares em uma aposta apartir dela verifica se essa
                quantidade está entre o mínimo e máximo estipulado.
                <br> Por exemplo na aposta
                <span class="black">03 </span>
                <span class="red">04 </span>
                <span class="black">05 </span>
                <span class="red">06 </span>
                <span class="red">08 </span>
                <span class="black">09 </span>
                <span class="red">10 </span>
                <span class="green">16 </span>
                <span class="black">17 </span>
                <span class="green">18 </span>
                <span class="black">21 </span>
                <span class="blue">22 </span>
                a sequência considerada é:
                <span class="red">04 06 08 10 </span>
                <br>
                    Observe que os ímpares da aposta são desconsiderados, então se existe ou não pares entre a sequencia
                    é irrelevante.
            </mat-card>
        </div>
        <div *ngIf="filter.filterTypeId == 12">
            <mat-card>
                Esse filtro soma todas as dezenas das apostas e verifica se o total está entre o mínimo e máximo
                estipulado para o filtro
            </mat-card>
        </div>

        <div *ngIf="filter.filterTypeId == 13">
            <mat-card>
                Esse filtro considera todas as diagonais, independentemente do sentido. Sendo que a diagonal com mais dezenas deverá estar entre o máximo e mínimo estipulado no filtro.
            </mat-card>
        </div>

        <div *ngIf="filter.filterTypeId == 14">
            <mat-card>
           Esse filtro considera todas as distâncias entre as dezenas em sequencia. Considera-se que o primeiro número está distante do Zero. Também é conhecido como intervalo entre dezenas
           <br>Exemplo:
           <br>02 05 10 11 15 21  
           <br>
           <br>Primeira Distância  (02 menos 00) = 2
           <br>Segunda  Distância  (05 menos 02) = 3           
           <br>Terceira Distância  (10 menos 05) = 5           
           <br>Quarta   Distância  (11 menos 10) = 1           
           <br>Quinta   Distância  (15 menos 11) = 4           
           <br>Sexta    Distância  (21 menos 15) = 6

            </mat-card>
        </div>
        <div *ngIf="filter.filterTypeId == 15">
            <mat-card>
                Esse filtro soma  considera a soma de todas as distâncias calculadas.
            </mat-card>
        </div>
     <div *ngIf="filter.filterTypeId == 17">
            <mat-card>
                Esse filtro utiliza os resultados ocorridos em concursos já sorteados.  Se estabelece um mínimo e um máximo e a aposta é comparada com todas as apostas anteriores e é aprovada se tiver semelhança entre o mínimo e máximo.
            </mat-card>
        </div>

    </div>

    <div class="col-md-4">

        <mat-form-field class="low-size-input">
            <input matInput placeholder="Mínimo" type="number" min="0" max="{{numberList.length}}" [value]="_min"
                (change)="changeMinLimit($event.target.value)">
        </mat-form-field>

        <mat-form-field class="low-size-input">
            <input matInput type="number" min="0" max="{{numberList.length}}" placeholder="Máximo" [value]="_max"
                (change)="changeMaxLimit($event.target.value)">
        </mat-form-field>

        <button *ngIf="showSaveButton" mat-raised-button color="accent" (click)="saveChanges()" [disabled]="!_saveButton">
            Salvar novos limites
          </button>
    </div>


</div>